import { useState, useEffect } from 'react';
import { Container, Grid, Button, Typography }from '@material-ui/core';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import UsersGrid from '../components/Users/UsersGrid';
import CreateUserDialog from '../components/Users/CreateUserDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useUserContext } from '../context/UserContext';
import { userActionTypes } from '../app/enums';
import { UserType } from '../models/user.interface';
import { Location } from '../models/location.interface';
import { Users as UserService, Locations } from '../api/api';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { drawerWidth } from '../app/common';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    xlcontainer: {
      padding: 20,
      marginLeft: drawerWidth,
      marginRight: drawerWidth,
      maxWidth: '1580px',
    },
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
    gridSpacer: {
      minHeight: '12px',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#ffffff',
    },
  }),
);

export const defaultUserType: UserType ={ 
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  userName: '',
  password: '',
  authenticated: false,
  locations: [],
  enabled: false,
  settings: '',
  userType: '',
}

export const Users = () => {
  const classes = useStyles(); 
  const [ open, setOpen ] = useState<boolean>(false);
  const [ locationList, setLocationList ] = useState<Location[]>([]);
  const [ load, setLoad ] = useState<boolean>(false);
  const [ loading, setLoading ] = useState<boolean>(false);
  const { dispatch } = useUserContext();

  useEffect(() => {
    Locations.getAllLocations()
    .then((locList) => {
      setLocationList(locList.sort((a,b) => (a.name > b.name) ? 1 : -1))
    })
  },[])

  useEffect(() => { 
    setLoading(true)

    UserService.getAllUsers()
      .then((users) => {
        let counter: number = 0;

        dispatch({ type: 'field', fieldName: 'usersList', payload: users})
        
        users.map((user) => {
          Locations.getLocations(user.id)
            .then((locations) => {
              counter++
              dispatch({ type: userActionTypes.UPDATE_USER_LIST, userId: user.id, locations: locations})

              if(counter === users.length)
                setLoading(false)
            })
        })
      })
  },[load])

  const handleCreateUserClick = () => {
    setOpen(true);
    setLoad(false)
  }

  const handleClose = () => {
    setOpen(false);
    setLoad(true)
  };

  const toggleLoad = () => {
    setLoad(!load)
  }

  return (
    <Container
      component="main"
      className={classes.xlcontainer}
    >
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography className={classes.pageTitle} variant="h5">
            Users
          </Typography>
        </Grid>
        <Grid item>
          <Button 
            variant="contained"
            color="primary"
            size="small" 
            startIcon={<PersonAddIcon/>}
            onClick={handleCreateUserClick}
          >
            Create User
          </Button> 
        </Grid>
      </Grid>
      <Grid container className={classes.gridSpacer} /> 
      <Grid container className={classes.gridSpacer} />
      <Grid container >
        { loading 
          ?
            <Grid container 
              justifyContent="center"
              alignItems="center" 
            >
              <CircularProgress color="primary" />
            </Grid>
          : <UsersGrid
              locationList={locationList}
              reloadList={toggleLoad}
            />
        }
      </Grid>
      <CreateUserDialog 
        open= {open}
        onClose={handleClose} 
        locationList={locationList}
      /> 
    </Container>
  );
};

export default Users;